import React, { useContext, useMemo, useState } from 'react';
import CurrentUserContext from '../../../../../contexts/CurrentUserContext';
import getIdentifier from '../../../../../getIdentifier';
import getTimeStamp from '../../../../../getTimeStamp';
import useSaveWidget from '../../../hooks/useSaveWidget';
import WidgetFooter from '../../WidgetFooter';
import FormInput from '../../../../../kingpin/forms/FormInput';
import { WidgetWrapper } from '../MetricSlideoutWizard/styles';
import Inputs from 'components/Inputs';
import ShadowedList from '../../../../ShadowedList';
import { useBonusConfigOptions } from '../BonusTotalRewardWizard';
import FactTableFieldsInput from '../FactTableFieldsInput';
import RenderModeInput from '../RenderModeInput';

const BonusEligibilityWizard = ({
  close,
  editingSection,
  lockedBonusConfigId,
}: {
  close: () => void;
  editingSection?: PerformanceBoardTypes.SlideOut.BonusEligibilitySection;
  lockedBonusConfigId?: string;
}) => {
  const { id: currentUserId } = useContext(CurrentUserContext);
  const { bonusConfigId, bonusConfigOptions } = useBonusConfigOptions({
    editingSection,
    lockedBonusConfigId,
  });
  const [factTableFields, setFactTableFields] = useState<string[]>(
    editingSection?.factTableFields ?? [],
  );
  const [renderMode, setRenderMode] = useState<
    'auto' | 'table' | 'cards' | undefined
  >(editingSection?.renderMode);

  const title = useMemo(() => {
    const selectedConfig = bonusConfigOptions.find((o) => o.isSelected);
    if (selectedConfig) {
      return `${selectedConfig.label} Eligibility`;
    }

    return '';
  }, [bonusConfigOptions]);

  const draftSection = useMemo(():
    | PerformanceBoardTypes.SlideOut.BonusEligibilitySection
    | undefined => {
    if (!bonusConfigId) {
      return undefined;
    }
    return {
      id: editingSection ? editingSection.id : getIdentifier(),
      sectionType: 'Bonus Eligibility',
      title,
      bonusConfigId,
      factTableFields,
      renderMode,
      createdOn: editingSection ? editingSection.createdOn : getTimeStamp(),
      createdBy: editingSection ? editingSection.createdBy : currentUserId,
      updatedBy: currentUserId,
      updatedOn: getTimeStamp(),
    };
  }, [
    bonusConfigId,
    currentUserId,
    editingSection,
    title,
    factTableFields,
    renderMode,
  ]);

  const saveWidget = useSaveWidget({
    section: draftSection,
    editingSection,
  });

  return (
    <>
      <ShadowedList>
        <WidgetWrapper>
          <FormInput label={'Bonus Program'}>
            <Inputs.Dropdown options={bonusConfigOptions} />
          </FormInput>
          <FactTableFieldsInput
            bonusConfigId={bonusConfigId}
            fields={factTableFields}
            setFields={setFactTableFields}
          />
          <RenderModeInput value={renderMode} setValue={setRenderMode} />
        </WidgetWrapper>
      </ShadowedList>

      <WidgetFooter
        saveWidget={saveWidget}
        sectionType="Bonus Eligibility"
        isDisabled={draftSection === undefined}
        close={close}
      />
    </>
  );
};

export default BonusEligibilityWizard;
